<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="studioOperationsModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="si-container">
    <app-studio-inquiry-sidebar [activeStep]="2"></app-studio-inquiry-sidebar>

    <form class="si-application" [formGroup]="operationsForm" (ngSubmit)="onNext()">
      <div class="si-section so-section">
        <div class="so-block so-block-divided">
          <div class="so-header">
            <h2 class="si-question so-header-title">
              {{constants.locationChoice}}<span class="star-red">*</span>
            </h2>
            <a class="si-link" *ngFor="let link of constants.locationLinks" [href]="link.url" target="_blank"
              rel="noopener">
              {{link.label}}
              <img src="../assets/images/link-icon.svg" alt="" class="si-link-icon">
            </a>
          </div>

          <div class="so-locations">
            <div class="common-checkbox-button so-checkbox">
              <input type="checkbox" class="common-checkbox-input" id="soundStages" formControlName="soundStages" />
              <label class="common-checkbox-label so-checkbox-label" for="soundStages">{{constants.soundStages}}</label>
            </div>

            <div class="common-checkbox-button so-checkbox">
              <input type="checkbox" class="common-checkbox-input" id="exteriorSets" formControlName="exteriorSets" />
              <label class="common-checkbox-label so-checkbox-label"
                for="exteriorSets">{{constants.exteriorSets}}</label>
            </div>

            <div class="so-sets-grid" formGroupName="exteriorSetSelections">
              <div class="common-checkbox-button so-checkbox" *ngFor="let option of constants.exteriorSetOptions"
                [class.so-sets-full]="option.id === 'other'">
                <input type="checkbox" class="common-checkbox-input" [id]="'set-' + option.id"
                  [formControlName]="option.id" />
                <label class="common-checkbox-label so-checkbox-label"
                  [for]="'set-' + option.id">{{option.name}}</label>
              </div>
            </div>
          </div>

          <div class="so-block">
            <h2 class="si-question">{{constants.additionalRequirements}}</h2>
            <textarea class="form-control common-text-area so-textarea" id="additionalRequirements"
              formControlName="additionalRequirements" [placeholder]="constants.additionalRequirementsPlaceholder"
              rows="4"></textarea>
          </div>
        </div>

        <div class="so-block">
          <h2 class="si-question">
            {{constants.officeSpaceQuestion}}<span class="star-red">*</span>
          </h2>
          <div class="so-office-options">
            <div class="common-radio-btn" *ngFor="let option of constants.officeSpaceOptions; let i = index">
              <input class="common-radio-input mb-0" type="radio" name="officeSpaceRequired"
                formControlName="officeSpaceRequired" [id]="'officeSpace-' + i" [value]="option" />
              <label class="common-radio-label" [for]="'officeSpace-' + i">{{option}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="si-buttons">
        <div class="si-back">
          <img src="../assets/images/blue-left-icon.svg" alt="" class="si-back-icon">
          <a class="text-link si-back-link" tabindex="0" (click)="onBack()" (keydown.enter)="onBack()"
            (keydown.space)="onBack()">{{constants.back}}</a>
        </div>
        <button type="submit" class="btn common-btn-secondary"
          [disabled]="operationsForm.invalid">{{constants.next}}</button>
      </div>
    </form>
  </div>
</div>
